import { cn } from "@gigpro/ui/tailwind/cn";
import { Progress as ProgressPrimitive } from "radix-ui";
import type * as React from "react";

export interface LinearProgressProps extends Omit<React.ComponentProps<typeof ProgressPrimitive.Root>, "max"> {}

const LinearProgress = ({ className, value = null, ...props }: LinearProgressProps) => (
  <ProgressPrimitive.Root
    value={value}
    className={cn("relative h-0.5 w-full overflow-hidden rounded-full bg-brand/20", className)}
    {...props}
  >
    <div className="relative size-full bg-brand/20">
      <ProgressPrimitive.Indicator
        className="absolute inset-y-0 inset-s-0 bg-brand transition-all data-[state=indeterminate]:animate-progress"
        style={value === null ? undefined : { width: `${value}%` }}
      />
    </div>
  </ProgressPrimitive.Root>
);
LinearProgress.displayName = "LinearProgress";

export { LinearProgress };
